var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"enter":_vm.afterEnter,"before-enter":_vm.beforeEnter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"ball",staticClass:"move_dot"},[_c('img',{attrs:{"width":"36","height":"36","src":_vm.dropImage,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }